import Alert from '@mailstep/design-system/ui/Elements/Alert'
import { t } from '@lingui/macro'
import React, { FC } from 'react'

const BaselinkerAlert: FC = () => {
  return (
    <Alert
      intent="danger"
      title={t({
        id: 'form.baselinkerDataCorrupted.title',
        message: 'BaseLinker data got corrupted.',
      })}
      text={t({
        id: 'form.baselinkerDataCorrupted.text',
        message: 'Please contact support. Submitting form will overwrite old config.',
      })}
    />
  )
}

export default BaselinkerAlert
